// extracted by mini-css-extract-plugin
module.exports = {"continueButton":"src-lib-app-containers-CreateAccount-RegistrationComplete-DesktopRegistrationComplete-index-module__continueButton--1KXjR"};